import React from 'react';
import getMessages from '../api/getMessages';

const useMessages = (culture: string): Record<string, string> | null => {
  const [messages, setMessages] = React.useState<Record<string, string> | null>(null);
  React.useEffect(() => {
    const { cancel } = getMessages({ culture, version: '2' })
      .then((res) => setMessages(res))
      .catch(() => setMessages(null));
    return cancel;
  }, [culture]);

  return messages;
};

export default useMessages;
